import type { RouterOutputs } from '@package/api'

type ReadingJournalRow = RouterOutputs['metrics']['getReadingJournal']['journals'][number]

/** A reading day is "starred" when total duration reaches this many minutes. */
export const STAR_MIN_MINUTES = 15

export function isStarredSession(totalDurationSeconds: number): boolean {
  return totalDurationSeconds / 60 >= STAR_MIN_MINUTES
}

/** Total stars for the week = number of days that reached the star threshold. */
export function countStars(data: ReadingJournalRow): number {
  return data.sessions.filter((s) => isStarredSession(s.totalDurationSeconds)).length
}
